// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__25e0T","colMin":"styles_colMin__2RtN6","colCheckbox":"styles_colCheckbox__3zCBy"};